/*----------------------------------------------------

	Scarousel.js
	// scroll based carousel

----------------------------------------------------*/

function initScarousel(sc_container){

	let autoplay_interval, scroll_amount, nav;
	const base_interval = 7000;
	const scroll_interval = 750;

	console.log('init: scarousel');

	// get settings
	const settings_attr = sc_container.dataset.scarousel;
	const settings_array = settings_attr.split(';').map(setting => setting.trim());
	const settings = {};
	settings_array.forEach(setting => {
		if(setting !== ""){
			const [key, value] = setting.split(':').map(part => part.trim());
			settings[key] = value === 'true' ? true : value === 'false' ? false : isNaN(value) ? value : parseFloat(value) || value;
		}
	});


	/*const first_child_style = getComputedStyle(sc_container.firstElementChild);
	scroll_amount = first_child_style.minWidth === '100%' ? sc_container.firstElementChild.clientWidth : parseInt(first_child_style.minWidth);*/

  const getSlideWidth = () => {
    let element = sc_container.firstElementChild;
    while(element && getComputedStyle(element).display === 'contents'){
      element = element.firstElementChild;
    }
    return element ? element.getBoundingClientRect().width : 0;
  };			
	scroll_amount = getSlideWidth();
	
	
	// gap
	const getGap = () => {
		const visible = getChildren(sc_container).filter(el => el.offsetParent !== null);

		if (visible.length < 2) return 0;

		const first_rect = visible[0].getBoundingClientRect();
		const second_rect = visible[1].getBoundingClientRect();

		return Math.max(0, second_rect.left - first_rect.right);
	};

	let gap = getGap();
	/*var gap = Number.isInteger(parseInt(getComputedStyle(sc_container).gap)) ? parseInt(getComputedStyle(sc_container).gap) : 0;*/


	// add navigation
	if(typeof settings.navigation !== 'undefined' && settings.navigation !== null){
		switch(settings.navigation){

			// prev / next navigation
			case 'prevnext':
				buildPrevNextNavigation();
				break;

			// prev / next navigation
			case 'paging':
				buildPagingNavigation();
				break;

			default:
				// no nothing
				break;

		}
	}

	// add autoplay
	const initiateAutoplay = () => {
		// only autoplay after video has loaded, as requires duration of video
		// queryselector will get the first video in the list only
		const video = sc_container.querySelector('video');
		if(video){
				hasVideoLoaded(video, autoplayCarousel);
		}else{
				autoplayCarousel();
		}

		// cancel autoplay on touch
		sc_container.addEventListener("touchstart", cancelAutoPlay);

	};

	if(settings.autoplay === true){
		initiateAutoplay();
	}


	// update scroll amount
	// =========================================================================================================================

	/*const updateScrollAmount = () => {
		const first_child_style = getComputedStyle(sc_container.firstElementChild);
		scroll_amount = first_child_style.minWidth === '100%' ? sc_container.firstElementChild.clientWidth : parseInt(first_child_style.minWidth);
	};

	window.addEventListener('resize', updateScrollAmount);*/

  const updateMeasurements = () => {
    scroll_amount = getSlideWidth();
    gap = getGap();
  };

  window.addEventListener('resize', updateMeasurements);




	// animation
	// =========================================================================================================================

	function slideCarousel(next_slide = false){
    
    console.log('scroll_amount : ' + scroll_amount);
		console.log('gap : ' + gap);
    console.log('scroll_amount + gap : ' + (scroll_amount + gap));

		// find out the current slide in view
		const step = scroll_amount + gap;
		if(!step){
				return;
		}

		var current_index = Math.floor(sc_container.scrollLeft / step);
		const visible_items = getChildren(sc_container).filter(el => el.offsetParent !== null);
		const total = visible_items.length;

    //console.log('scrollLeft : ' + sc_container.scrollLeft);
    //console.log('current_index : ' + current_index);
		//console.log('sc_container.children.length : ' + sc_container.children.length);
		//console.log('total : ' + total);

    
    // adjust for items smaller that width of container
    var current_index_left = ((current_index * gap) + (current_index * scroll_amount));
		const offset = gap === 0 ? 10 : 0;

    //console.log('current_index_left : ' + current_index_left);
    //console.log('offset : ' + offset);
    //console.log('sc_container.scrollLeft - offset : ' + (sc_container.scrollLeft - offset));

    const epsilon = 1; // allow for subpixel comparison
		if((sc_container.scrollLeft - offset) > current_index_left + epsilon){
			current_index += 1;
		}

		// add 1 to this number, or set to 1 if it's equal to the number of children
		if(Number.isInteger(next_slide)){
			var next_index = next_slide;
		}else if(next_slide === true){
			var next_index = (current_index - 1 + total) % total;
		}else{
			var next_index = (current_index + 1) % total || 0;
       //console.log('next_slide current_index : ' + current_index);
       //console.log('next_slide total : ' + total);
		}


    // adjust for items smaller that width of container 
    const isAtEnd = () => {
      const max_scroll = sc_container.scrollWidth - sc_container.clientWidth;
      return sc_container.scrollLeft >= max_scroll - 1; // tolerance for sub-pixels
    };
    if(isAtEnd() && next_slide === false){
      next_index = 0;
    }
    
    to_scroll_amount = (scroll_amount * next_index) - 10; // reduce by ten to avoid sub-pixels breaking the scroll
    to_scroll_amount += (gap * next_index);

    console.log('next_index : ' + next_index);
    console.log('scroll_amount : ' + scroll_amount);
    console.log('to_scroll_amount : ' + to_scroll_amount);
		console.log('done');
    
		// Use this to run slider_container.scrollLeft
		sc_container.scrollLeft = to_scroll_amount;

		// update current
		updateCurrentPaging();

	}




	// autoplay
	// =========================================================================================================================

	// play
	function autoplayCarousel(){

		// find current slide (after scroll)
		const current_index = Math.floor(sc_container.scrollLeft / scroll_amount);
    const current_slide = getChildren(sc_container)[current_index];
    const video = current_slide.querySelector('video');


		// get interval, minus scroll delay
		const calculateInterval = () => {
			return video ? getVideoLength(video) - scroll_interval : base_interval - scroll_interval;
		};


		const restartAutoplay = () => {
			// move to next slide
			slideCarousel();
			// delay restarting autoplay so current scroll has time to complete
			setTimeout(autoplayCarousel, scroll_interval);
		};

		// set autoplay
		autoplay_interval = setTimeout(restartAutoplay, calculateInterval());

	}

	// stop
	function cancelAutoPlay(){
		clearTimeout(autoplay_interval); 
	}




	// video
	// =========================================================================================================================

	// duration
	function getVideoLength(video){
		return video.duration * 1000; // convert to milliseconds
	}

	// has loaded
	function hasVideoLoaded(video, callback){

		// if video already loaded
		if(video.readyState == 4){
			if(typeof callback === 'function'){
				callback();
			}

		// else listen to onloadedmetadata event
		}else{
			video.onloadedmetadata = function(){
				if(typeof callback === 'function'){
					callback();
				}
			};
		}

	}




	// prev / next navigation
	// =========================================================================================================================

	// build
	function buildPrevNextNavigation(){

		const existing_nav = sc_container.querySelector('.scarousel__nav');

    if(!existing_nav){
        const nav_to_add = document.createElement("nav");
        nav_to_add.classList.add('scarousel__nav', 'scarousel__nav--prevnext');

        const createBtn = (cls, label, icon) => {
            const btn = document.createElement("button");
            btn.setAttribute("aria-label", label);
            loadSVG(icon).then(svg => {
                if (svg) btn.insertAdjacentHTML("afterbegin", svg);
            });
            return btn;
        };

        const prev_btn = createBtn('scarousel__btn--prev', 'Previous slide', 'icon-arrow-right');
        const next_btn = createBtn('scarousel__btn--next', 'Next slide', 'icon-arrow-right');

        nav_to_add.append(prev_btn, next_btn);
        sc_container.after(nav_to_add);

        nav = nav_to_add;

        bindPrevNextNavigation();
    }

	}


	// bind click
	function bindPrevNextNavigation(){

		// get nav links
		var nav_links = nav.querySelectorAll('button');

		// loop and attach click events
		[].forEach.call(nav_links, function(nl){
			nl.addEventListener('click', function(e){
				e.preventDefault();

				// prev
				if(!nl.previousElementSibling){
					slideCarousel(true);

				// next
				}else if(!nl.nextElementSibling){
					slideCarousel();
				}

				cancelAutoPlay();

			});
		});

	}




	// prev / next navigation
	// =========================================================================================================================

	// build
	function buildPagingNavigation(){

		const existing_nav = sc_container.querySelector('.scarousel__nav');

    if(!existing_nav){
        const nav_to_add = document.createElement("nav");
        nav_to_add.classList.add('scarousel__nav', 'scarousel__nav--paging');

				// works instead of for loop, creates array and implodes
        const navHtml = Array.from({ length: getChildren(sc_container).length }, (_, i) => '<button><span class="screen-reader-only">' + (i + 1) + '</span></button>').join('');
        nav_to_add.innerHTML = navHtml;

        sc_container.after(nav_to_add);

        nav = sc_container.nextElementSibling;

        updateCurrentPaging();

        bindPagingNavigation();

    }

	}


	// bind click
	function bindPagingNavigation(){

		// get nav links
		var nav_links = nav.querySelectorAll('button');

		// loop and attach click events
		[].forEach.call(nav_links, function(nl){
			nl.addEventListener('click', function(e){
				e.preventDefault();

				// get index of current slide
				var next_slide = Array.prototype.indexOf.call(nl.parentElement.children, nl);

				slideCarousel(next_slide);

				updateCurrentPaging();
			
				cancelAutoPlay();

			});
		});

	}


	// update current pos
	function updateCurrentPaging(){

		// arrow function notation | name = [function/variables] [arrow] [contents]
		const clearPreviousCurrent = () => {
			const prevCurrent = nav.querySelector('[aria-current]');
			if(prevCurrent){
				prevCurrent.removeAttribute('aria-current');
			}
		};

		const setCurrentNavItem = () => {
				const current_index = Math.floor(sc_container.scrollLeft / scroll_amount);
				const matching_nav_item = nav.children[current_index];
				if(matching_nav_item){
						matching_nav_item.setAttribute('aria-current', 'true');
				}
		};

		// delay updating current until after scroll
		setTimeout(() => {
				clearPreviousCurrent();
				setCurrentNavItem();
		}, scroll_interval);

	}

}





// get children
// =========================================================================================================================

function getChildren(element){
  const children = [];
  for(const child of element.children){
    if(getComputedStyle(child).display === 'contents'){
      children.push(...getChildren(child));
    }else{
      children.push(child);
    }
  }
  return children;
}





// init all carousels
// =========================================================================================================================

var all_scarousels = document.querySelectorAll('[data-scarousel]');

all_scarousels.forEach(function(sc_container){

	(function check(){

		if(getComputedStyle(sc_container).display !== 'flex'){
			requestAnimationFrame(check);
			return;
		}

		if(getChildren(sc_container).length > 1){
			initScarousel(sc_container);
		}

	})();

});